export default __webpack_public_path__ + "assets/single-document.28a6321a.svg";